import { render, staticRenderFns } from "./frontorderreturn-edit.vue?vue&type=template&id=af1c5ac8&"
import script from "./frontorderreturn-edit.vue?vue&type=script&lang=ts&"
export * from "./frontorderreturn-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports